import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  ActivatedRoute,
  NavigationStart,
  ParamMap,
  Router,
} from '@angular/router';
import { FilterBaseVM } from '@payments/services/payments-modal.service';
import { PaymentsService } from '@payments/services/payments.service';
import { PATHS } from '@shared/constants/paths';
import { Filter, InvoiceFilterIds } from '@usf/ngrx-payment';
import { Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

@Component({
  template: '',
})
export class PaymentsBasePage {
  @ViewChild('mainDivScroll', { static: false }) mainScroll: ElementRef;
  @ViewChild('mainVirtualScroll', { static: false })
  mainVirtualScroll: CdkVirtualScrollViewport;
  queryParamMap: ParamMap;

  constructor(
    public router: Router,
    readonly route: ActivatedRoute,
    readonly paymentsService: PaymentsService,
  ) {}

  ionViewWillEnter(): void {
    this.queryParamMap = this.route.snapshot.queryParamMap;

    this.router.events
      .pipe(
        first(event => event instanceof NavigationStart),
        this.handleOutPayments,
      )
      .subscribe((event: NavigationStart) => {
        if (
          event.url?.endsWith(`/${PATHS.PAYMENTS}`) ||
          (!event.url?.includes(`/${PATHS.PAYMENTS_MAKE_PAYMENT}`) &&
            (!this.router.url.endsWith(`/${PATHS.PAYMENTS}`) ||
              !this.router.url.includes(`/${PATHS.PAYMENTS_MAKE_PAYMENT}`)))
        ) {
          this.paymentsService.clearSelectedInvoices();
        }
      });
  }

  private handleOutPayments = (
    navigationEvent: Observable<NavigationStart>,
  ): Observable<NavigationStart> => {
    return navigationEvent.pipe(
      tap(
        (event: NavigationStart) =>
          !event.url?.includes(`/${PATHS.PAYMENTS}`) && this.clearAll(),
      ),
    );
  };

  public clearAll() {
    this.paymentsService.clearSelectedInvoices();
    this.paymentsService.clearPaymentCustomer();
    this.paymentsService.clearPayments();
    this.paymentsService.clearEligibleADCustomers();
  }

  protected convertFilterDate(date: number): Date {
    if (!!date) {
      return new Date(
        Date.UTC(date / 10000, (date % 10000) / 100 - 1, date % 100),
      );
    }
    return null;
  }

  protected getFiltersFromParams(): Filter[] {
    const data = this.queryParamMap.keys.map(key => {
      let value = this.queryParamMap.getAll(key);
      let finalValue = value as Filter['value'];
      // Array values expect to have "," even if only one item
      if (value.length === 1 && value[0].indexOf(',') > 0) {
        finalValue = value[0].split(',').filter(v => v);
      } else if (value.length === 1) {
        finalValue = value[0];
      }
      if (
        Object.values(InvoiceFilterIds).find(
          filterId => filterId.toString() === key,
        ) &&
        finalValue
      ) {
        return {
          filterName: key,
          value: finalValue,
        };
      }
    });
    return data.filter(d => !!d);
  }

  protected getIssueDates(vm: FilterBaseVM): {
    fromIssueDate: number;
    toIssueDate: number;
  } {
    const fromIssueDate =
      (vm.filters.find(f => f.filterName === InvoiceFilterIds.FromIssueDate)
        ?.value as number) || null;
    const toIssueDate =
      (vm.filters.find(f => f.filterName === InvoiceFilterIds.ToIssueDate)
        ?.value as number) || null;
    return { fromIssueDate, toIssueDate };
  }

  protected routeTo(path: string, queryParams = {}) {
    this.router.navigate([path], { queryParams });
  }
}
